import moment from "moment";

export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SS[Z]';

export function setTimeToStartOfDay(date) {
  return moment(date)
    .startOf('day')
    .utc()
    .format(FULL_DATE_FORMAT)
}

export function setTimeToEndOfDay(date) {
  return moment(date)
    .endOf('day')
    .utc()
    .format(FULL_DATE_FORMAT);
}



// WEBPACK FOOTER //
// ./src/helpers/date.js